import { Typography } from 'design-component';
import React from 'react';
import styled from 'styled-components';
import { palette } from 'styles/color';

interface TableProps {
  headers: string[];
  rows: any[];
}

const CsvTable: React.FC<TableProps> = ({ headers, rows }) => {
  return (
    <div>
      <table style={{ borderCollapse: 'collapse' }}>
        <thead>
          <Tr>
            {headers.map((header, index) => (
              <Th key={index}>
                <Typography
                  component="div"
                  weight={600}
                  size="11px"
                  height="12px"
                  color={palette.gray[800]}
                  style={{ whiteSpace: 'pre' }}
                  align="left">
                  {header}
                </Typography>
              </Th>
            ))}
          </Tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <Tr key={rowIndex}>
              {headers.map((header, colIndex) => (
                <Td key={colIndex}>
                  <Typography
                    weight={400}
                    size="12px"
                    height="150%"
                    color={palette.gray[800]}
                    align="left">
                    {row[header] || ''}
                  </Typography>
                </Td>
              ))}
            </Tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CsvTable;
// style={{
//   border: '1px solid #ddd',
//   padding: '8px',
//   textAlign: 'left',
//   backgroundColor: '#f4f4f4'
// }}

const Th = styled.th`
  padding: 9px 16px;
  box-sizing: border-box;
  border: 1px solid ${palette.gray[200]};
  background-color: ${palette.gray[100]};
  // white-space: pre;
`;

const Tr = styled.tr`
  &:nth-child(odd) {
    background-color: ${palette.white};
  }
  &:nth-child(even) {
    background-color: ${palette.gray[100]};
  }
`;

const Td = styled.td`
  padding: 5.5px 16px;
  min-width: 65px;
  border: 1px solid ${palette.gray[200]};
`;
